// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Bhsu","row":"Node_row__waW3S","label":"Node_label__1cO3t","footer":"Node_footer__x9UE_"};